/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  XypeRegistry,
  XypeRegistryInterface,
} from "../../contracts/XypeRegistry";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "ERC721IncorrectOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ERC721InsufficientApproval",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "approver",
        type: "address",
      },
    ],
    name: "ERC721InvalidApprover",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "ERC721InvalidOperator",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "ERC721InvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "ERC721InvalidReceiver",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "ERC721InvalidSender",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ERC721NonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error",
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "RegistryNotAuthorized",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistryUnequalArrayLengths",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "SenderMustBeRegistrarOrRootNodeOwner",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "registrar",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "LogSetRegistrar",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "NewBaseURI",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "expiration",
        type: "uint64",
      },
    ],
    name: "NewExpiration",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "label",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "NewOwner",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "resolver",
        type: "address",
      },
    ],
    name: "NewResolver",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "nodes",
        type: "bytes32[]",
      },
    ],
    name: "batchBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "nodes",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "recipients",
        type: "address[]",
      },
    ],
    name: "batchMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "nodes",
        type: "bytes32[]",
      },
      {
        internalType: "uint64[]",
        name: "expirations",
        type: "uint64[]",
      },
    ],
    name: "batchSetExpiration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "nodes",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "owners",
        type: "address[]",
      },
    ],
    name: "batchSetOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "nodes",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "owners",
        type: "address[]",
      },
      {
        internalType: "uint64[]",
        name: "expirations",
        type: "uint64[]",
      },
    ],
    name: "bulkRegisterAndMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "expiration",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rootOwner",
        type: "address",
      },
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "baseURI_",
        type: "string",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "isAuthorized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "isRegistrar",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "resolver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newBaseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint64",
        name: "_expiration",
        type: "uint64",
      },
    ],
    name: "setExpiration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "_resolver",
        type: "address",
      },
    ],
    name: "setRecord",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "registrar",
        type: "address",
      },
      {
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "setRegistrar",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_resolver",
        type: "address",
      },
    ],
    name: "setResolver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "label",
        type: "bytes32",
      },
      {
        internalType: "uint64",
        name: "_expiration",
        type: "uint64",
      },
    ],
    name: "setSubnodeExpiration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "label",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    name: "setSubnodeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "label",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "_resolver",
        type: "address",
      },
    ],
    name: "setSubnodeRecord",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type XypeRegistryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: XypeRegistryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class XypeRegistry__factory extends ContractFactory {
  constructor(...args: XypeRegistryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      XypeRegistry & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): XypeRegistry__factory {
    return super.connect(runner) as XypeRegistry__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): XypeRegistryInterface {
    return new Interface(_abi) as XypeRegistryInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): XypeRegistry {
    return new Contract(address, _abi, runner) as unknown as XypeRegistry;
  }
}
